import gql from 'graphql-tag';

export const GET_TRAFFICKING_CUSTOM_FILTERS = gql`
  query GET_TRAFFICKING_CUSTOM_FILTERS($input: TraffickingCustomFiltersInput!) {
    traffickingCustomFilters(input: $input) {
      edges {
        node {
          id
          filterName
          filterType
          visibility
          createdBy
        }
      }
      total
    }
  }
`;
